import {QUERY_KEYS as AUTHENTICATION_QUERY_KEYS} from '@/features/authentication/queries/keys'
import {QUERY_KEYS as CHANNELS_QUERY_KEYS} from '@/features/chat/queries/keys'
import {PaymentError} from '@/features/guest-payments/types'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosResponse} from 'axios'
import {sendMegaGift} from '../services/megaGift.http'
import {MUTATION_KEYS} from './keys'

export const useSendMegaGift = ({hostID, onSuccess}: {hostID: string; onSuccess?: () => void}) => {
    const queryClient = useQueryClient()
    return useMutation<AxiosResponse, PaymentError, {hostID: string}>({
        mutationKey: [MUTATION_KEYS.sendMegaGift],
        mutationFn: () => sendMegaGift(hostID),
        onSuccess: () => {
            onSuccess?.()
            queryClient.invalidateQueries({queryKey: [AUTHENTICATION_QUERY_KEYS.user]})
            queryClient.invalidateQueries({queryKey: [CHANNELS_QUERY_KEYS.fetchChannels]})
        }
    })
}
